// Action creator to initialize the readiness analytics data.
// @flow
import * as _ from 'underscore';
import { initialize } from './initialize';
import { tableTransformerFactory } from '../../../../lib/transformer/TableTransformerFactory';
import { graphTransformerFactory } from '../../../../lib/transformer/GraphTransformerFactory';

import * as AnalyticsService from '../../../../api/service/AnalyticsService';
import * as AppState from '../../app/appState';
import { getInstanceMeta } from '../analytics';

// this is a local state variable of sorts will allow us to determine if the
// latest search params match any given request. We use it to make sure that
// the data returned is only from the latest request
let paramStorage = false;

export const initializeAnalytics = (
    metaKey: string,
    params: {},
    urlOverride: string = null
) => (dispatch: Function) => {
    // This is a workaround for a bug seen in testing where the contents of
    // this function were causing a test failure in some environments.
    // This shouldn't have impact on the calling code because the 'results'
    // of this logic is being dispatched to the redux store, which still
    // occurs in its current form.
    const asyncWrapper = async function() {
        const meta = await getInstanceMeta(metaKey);
        if (!meta) {
            return;
        }
        await fetchDataDebounced(meta, params, dispatch, urlOverride);
    };

    asyncWrapper();
};

export const fetchData = async (
    meta: {},
    params: {},
    dispatch: void,
    urlOverride: string = null
) => {
    AppState.setAnalyticsLoading();
    let hashedSearchParams = JSON.stringify(params);
    paramStorage = hashedSearchParams;
    const response = await AnalyticsService.fetchAnalytics(
        urlOverride || meta.url,
        params,
        (err: {}) => {
            AppState.setError(err);
            AppState.stopLoadingAnalytics();
        }
    );

    if (!response) {
        return;
    }

    let searchParamsMatchLatestQuery = paramStorage === hashedSearchParams;
    let title = response.title;

    if (searchParamsMatchLatestQuery) {
        // once the response comes, let's make sure the hashed params match the
        // latest meta data
        const tableTransformer = tableTransformerFactory(meta.key);
        const { columns, rows } = tableTransformer.transform(response);
        let graphData;
        if (response) {
            const graphTransformer = graphTransformerFactory(
                meta.key,
                params,
                response.isCombinedData ? response.graph.title : response.title
            );
            graphData = graphTransformer.transformData(
                response.isCombinedData ? response : response.rows
            );
        }
        const kpi = response.kpis;
        const defaultSort = getDefaultSort(meta);
        dispatch(initialize(title, columns, rows, defaultSort, graphData, kpi));
        AppState.stopLoadingAnalytics();
    }
};

const fetchDataDebounced = _.debounce(fetchData, 250);

const getDefaultSort = (meta: {}) => {
    if (!meta.default_sort) {
        return null;
    }
    return [
        {
            dataField: meta.default_sort.data_field,
            order: meta.default_sort.order.toLowerCase()
        }
    ];
};



// WEBPACK FOOTER //
// ./src/state/reducer/analytics/actionCreators/initializeAnalytics.js